import { styled } from "@mui/system";
import { colors } from "../../config/colors";
import { Button } from "react-bootstrap";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_SM,
  FONT_SIZE_MD,
  FONT_SIZE_LG,
  LINE_HEIGHT_SM,
  LINE_HEIGHT_MD,
  BORDER_RADIUS_SM,
  BORDER_RADIUS_MD,
  FONT_SIZE_CUSTOM_LG,
} from "../../config/styles";

export const PayByLinkStyled = styled("div")(({ theme }) => ({
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    padding: "0px 40px",
    marginLeft: "256px",
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: "12px 0px",
    minHeight: "calc(100vh - 100px)",
}));

export const SkeletonWrapper = styled("div")(() => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  gap: "2px",
}));

export const PayByLinkListStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  gap: "16px",
  width: "100%",
  "& .toolbar": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: "stretch",
  },
  "& .search-filters": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
    flexWrap: "wrap",
  },
  "& .toggled .label14": {
    color: "#000000 !important",
  },
  "& .toggledActive .label14": {
    color: "#000000 !important",
  },
  "& .toggled .dropdownTriangle": {
    filter: "brightness(0) !important",
  },
  "& .toggledActive .dropdownTriangle": {
    filter: "brightness(0) !important",
  },
  "& .search-input-wrapper": {
    position: "relative",
    display: DISPLAY_FLEX,
    width: "280px",
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .search-input": {
    display: DISPLAY_FLEX,
    height: "36px",
    width: "100%",
    padding: "8px 12px",
    paddingRight: "40px",
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    alignSelf: "stretch",
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    background: colors.surface,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.nonActive,
    outline: "none",
    "&::placeholder": {
      color: colors.nonActive,
    },
    "&:focus": {
      borderColor: colors.primary,
      color: "#000000",
    },
    "&:not(:placeholder-shown)": {
      color: "#000000",
    },
  },
  "& .search-icon": {
    position: "absolute",
    right: "12px",
    pointerEvents: "none",
  },
  "& .text-input-wrapper": {
    display: DISPLAY_FLEX,
    width: "150px",
  },
  "& .text-input": {
    display: DISPLAY_FLEX,
    height: "36px",
    width: "100%",
    padding: "8px 12px",
    alignItems: FLEX_ALIGN_CENTER,
    borderRadius: BORDER_RADIUS_SM,
    border: `1px solid ${colors.grayBackground}`,
    background: colors.surface,
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.custom,
    outline: "none",
    "&::placeholder": {
      color: colors.nonActive,
    },
    "&:focus": {
      borderColor: colors.primary,
    },
  },
  "& .date-picker-wrapper": {
    width: "150px",
    "& .MuiOutlinedInput-root": {
      height: "36px",
      fontSize: FONT_SIZE_MD,
      fontFamily: "Open Sans, sans-serif",
      color: "#000000",
      "& fieldset": {
        borderColor: colors.grayBackground,
        borderRadius: BORDER_RADIUS_SM,
      },
      "&:hover fieldset": {
        borderColor: colors.primary,
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.primary,
      },
    },
    "& .MuiInputBase-input": {
      padding: "8px 12px",
      fontSize: FONT_SIZE_MD,
      fontFamily: "Open Sans, sans-serif",
      color: "#000000",
    },
  },
  "& .date-range-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    gap: "8px",
  },
  "& .ag-grid-container": {
    width: "100%",
    "& .ag-theme-material": {
      width: "100%",
      height: "600px",
      "--ag-pinned-column-border": "none",
    },
    "& .ag-root-wrapper": {
      border: `1px solid ${colors.storkeLight}`,
      borderRadius: BORDER_RADIUS_SM,
    },
    "& .ag-header": {
      backgroundColor: colors.background,
      borderBottom: `1px solid ${colors.storkeLight}`,
    },
    "& .ag-header-cell": {
      display: DISPLAY_FLEX,
      height: "42px",
      padding: "0 24px !important",
      alignItems: FLEX_ALIGN_CENTER,
      justifyContent: "flex-start",
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "500 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.nonActive} !important`,
      overflow: "visible",
    },
    "& .ag-header-cell-label": {
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
      padding: "0 !important",
      margin: "0 !important",
      display: "flex",
      alignItems: "center",
    },
    "& .ag-header-cell-text": {
      textAlign: "left",
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "nowrap",
    },
    "& .ag-header-cell-center": {
      justifyContent: "center",
    },
    "& .ag-row": {
      display: DISPLAY_FLEX,
      height: "52px",
      alignItems: FLEX_ALIGN_CENTER,
      cursor: "pointer",
      borderBottom: `1px solid ${colors.storkeLight} !important`,
      "&:last-child": {
        borderBottom: "none !important",
      },
      "&:hover": {
        backgroundColor: `${colors.hoverBackground} !important`,
      },
    },
    "& .ag-cell": {
      display: DISPLAY_FLEX,
      padding: "0 24px !important",
      alignItems: FLEX_ALIGN_CENTER,
      fontSize: `${FONT_SIZE_MD} !important`,
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "400 !important",
      fontStyle: "normal",
      lineHeight: "18px !important",
      letterSpacing: "0 !important",
      color: `${colors.custom} !important`,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .ag-cell-center": {
      justifyContent: "center !important",
      textAlign: "center !important",
    },
    "& .skeleton-loader": {
      display: DISPLAY_FLEX,
      flexDirection: FLEX_DIRECTION_COLUMN,
      width: "100%",
      border: `1px solid ${colors.storkeLight}`,
      borderRadius: BORDER_RADIUS_SM,
      padding: "16px",
      gap: "8px",
    },
  },
  "& .action-button": {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    transition: "opacity 0.2s",
    "&:hover": {
      opacity: 0.7,
    },
  },
}));


export const PayByLinkDetailsStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  padding: "0px 40px",
  marginLeft: "256px",
  backgroundColor: theme.palette.secondary.contrastText,
  borderRadius: "12px 0px",
  minHeight: "calc(100vh - 100px)",
  gap: "16px",
  
  "& .section-part": {
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    border: `1px solid ${colors.storkeLight}`,
    borderRadius: BORDER_RADIUS_MD,
    background: colors.surface,
  },

  "& .section-title": {
    fontSize: FONT_SIZE_LG,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: LINE_HEIGHT_MD,
    color: colors.custom,
    marginBottom: "16px",
    alignSelf: "flex-start",
  },

  "& .info-grid": {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
    width: "100%",
    "@media (max-width: 1400px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },

  "& .info-item": {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },

  "& .info-label": {
    fontSize: FONT_SIZE_SM,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: LINE_HEIGHT_SM,
    color: colors.nonActive,
  },

  "& .info-value": {
    fontSize: FONT_SIZE_MD,
    fontFamily: "Open Sans, sans-serif",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.custom,
  },

  "& .url-container": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  "& .copy-button": {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      opacity: 0.7,
    },
  },
}));

export const CancelPayByLinkButton = styled(Button)(({ disabled }) => ({
  display: DISPLAY_FLEX,
  height: "36px",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: FLEX_ALIGN_CENTER,
  gap: "8px",
  borderRadius: BORDER_RADIUS_SM,
  border: "none !important",
  background: `${disabled ? colors.disabled : colors.warning} !important`,
  color: `${colors.white} !important`,
  fontSize: FONT_SIZE_MD,
  fontFamily: "Open Sans, sans-serif",
  fontWeight: FONT_WEIGHT_MEDIUM,
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? colors.disabledOpacity + 0.1 : 1,
  transition: "all 0.2s",
  "&:hover": {
    background: `${disabled ? colors.disabled : colors.warningHover} !important`,
    color: `${colors.white} !important`,
  },
  "&:focus": {
    boxShadow: "none",
    background: `${disabled ? colors.disabled : colors.warning} !important`,
  },
  "&:active": {
    background: `${disabled ? colors.disabled : colors.warningHover} !important`,
  },
}));
